import { render, staticRenderFns } from "./SvehicleinvoiceView.vue?vue&type=template&id=e0d22276&scoped=true"
import script from "./SvehicleinvoiceView.vue?vue&type=script&lang=js"
export * from "./SvehicleinvoiceView.vue?vue&type=script&lang=js"
import style0 from "./SvehicleinvoiceView.vue?vue&type=style&index=0&id=e0d22276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d22276",
  null
  
)

export default component.exports